/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDialogMessage } from 'src/app/@amiga-pyme/components/ami-dialog-message/ami-dialog-message.interface';
import { ISettingsTable } from '../../interfaces/table.interface';
import { IEventAction } from '../../table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableActionsBaseTemplate } from '../../table-actions/templates/table-actions-base.template';

@Component({
  template: ''
})
export class TableExpansionBaseTemplate extends TableActionsBaseTemplate {
  @Output() itemChildSelected = new EventEmitter<IEventAction>();
  tableChild: { settings: ISettingsTable; data: any[]; actions: any } = {
    settings: {
      title: '',
      columns: []
    },
    data: null,
    actions: null
  };
  openChild = false;
  message: IDialogMessage;
  suscriptionBase$: Subscription;

  onCloseChild() {
    this.openChild = false;
  }

  onReciveActionChild(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      this.openChild = true;
      this.itemChildSelected.emit({ action, data });
    }
  }

  unsubscribeBase() {
    this.suscriptionBase$.unsubscribe();
  }
}
